<app-external-link [targetType]="targetType" linkType="stroked-button">
  <div class="left-icon-button rs-inline-button documentation-button">
    <span class="ri-documentation"></span>
    <span>Documentation</span>
  </div>
</app-external-link>
